<div class="content-wrapper">
  <div class="container-fluid">
    <div class="content-header" *ngIf="programCode">
      <ds-grid (completed)="onCompleted($event)" [filter]="programCode" applicationId="{{applicationId}}" [templates]="templates"></ds-grid>
    </div>
  </div>
</div>


<ng-template #avatarTemplate let-row>
  <div><img class="avatar" [src]="getImageColumn(row)"></div>
</ng-template>